import RaporHead from "../../../../../components/categories/siakad/laporan_adab/rapor_sync/HomeHead"
export default function Home() {
  
  return (
    <RaporHead />
  );
}